import layout from "../../constants/layout";
import NavBar from "../NavBar";
import { useState } from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
// import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import { useNavContext } from "../../context/NavContext";
// import { Drawer } from "@mui/material";

export default function SkeletonLayout() {
  const [navDrawerOpen, setNavDrawerOpen] = useState(false);
  const isLgUp = useMediaQuery((theme) => theme.breakpoints.up("lg"));
  const { isNavDisabled } = useNavContext();
  const marginLeft = isLgUp && !isNavDisabled ? layout.navDrawerWidth : 0;
  const { palette } = useTheme();

  return (
    <Box
      sx={{
        height: "100dvh",
        overflowY: "hidden",
        overflowX: "hidden",
        scrollbarWidth: "auto",
        backgroundColor: palette.background.default,
      }}
    >
      <NavBar
        navDrawerOpen={navDrawerOpen}
        setNavDrawerOpen={setNavDrawerOpen}
      />
      {/* <Drawer open={navDrawerOpen} variant={isLgUp ? "permanent" : "temporary"}>
        <Box
          sx={(theme) => ({
            width: `${layout.navDrawerWidth}rem`,
            marginTop: `${layout.navBarHeight}rem`,
            height: "100%",
            overflowY: "auto",
            backgroundColor: theme.palette.background.paper,
            display: "flex",
            justifyContent: "flex-start",
            flexDirection: "column",
          })}
        >
          <Skeleton
            component={"div"}
            variant="rectangle"
            sx={{ width: "100%", my: 0.5 }}
            height={50}
          />
          <Box
            sx={{
              flexDirection: "row",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Skeleton
              component={"span"}
              variant="rectangle"
              sx={{ width: "1%", my: 0.5, ml: 1 }}
              height={40}
            />
            <Skeleton
              component={"span"}
              variant="rectangle"
              sx={{ width: "90%", my: 0.5 }}
              height={40}
            />
          </Box>
          <Box
            sx={{
              flexDirection: "row",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Skeleton
              component={"span"}
              variant="rectangle"
              sx={{ width: "1%", my: 0.5, ml: 1 }}
              height={40}
            />
            <Skeleton
              component={"span"}
              variant="rectangle"
              sx={{ width: "90%", my: 0.5 }}
              height={40}
            />
          </Box>
          <Skeleton
            component={"div"}
            variant="rectangle"
            sx={{ width: "100%", my: 0.5 }}
            height={50}
          />
          <Box
            sx={{
              flexDirection: "row",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Skeleton
              component={"span"}
              variant="rectangle"
              sx={{ width: "1%", my: 0.5, ml: 1 }}
              height={40}
            />
            <Skeleton
              component={"span"}
              variant="rectangle"
              sx={{ width: "90%", my: 0.5 }}
              height={40}
            />
          </Box>
          <Box
            sx={{
              flexDirection: "row",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Skeleton
              component={"span"}
              variant="rectangle"
              sx={{ width: "1%", my: 0.5, ml: 1 }}
              height={40}
            />
            <Skeleton
              component={"span"}
              variant="rectangle"
              sx={{ width: "90%", my: 0.5 }}
              height={40}
            />
          </Box>
        </Box>
      </Drawer> */}
      <Box
        sx={{
          padding: "0 1rem",
          marginLeft: `${marginLeft}rem`,
          width: `calc(100vw - ${marginLeft}rem)`,
          height: "100dvh",
          overflowY: "auto",
          overflowX: "hidden",
          boxSizing: "border-box",
        }}
      >
        {/* <Grid
          container
          spacing={2}
          sx={{ height: "80%", paddingTop: `${layout.navBarHeight + 1}rem` }}
        >
          <Grid
            size={4}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Skeleton
              variant="rounded"
              sx={{ width: "100%", height: "100%" }}
            />
          </Grid>
          <Grid
            size={8}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Skeleton
              variant="rounded"
              sx={{ width: "100%", height: "100%" }}
            />
          </Grid>
          <Grid
            size={8}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Skeleton
              variant="rounded"
              sx={{ width: "100%", height: "100%" }}
            />
          </Grid>
          <Grid
            size={4}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Skeleton
              variant="rounded"
              sx={{ width: "100%", height: "100%" }}
            />
          </Grid>
        </Grid> */}
      </Box>
    </Box>
  );
}
